import {Box, Icon, Typography} from '@mui/material';
import {ReactComponent as SecurityIcon} from '@icons/security-safe.svg';
import {FC, useState} from 'react';
import Button from '@/shared/components/Button';
import {OUTLINE} from '@/utils/constants';
import {twoStepAuthenticationDisableStyles} from './TwoStepAuthentication.Disable.styles';
import {SuperAdminService} from '@/utils/services';
import {getErrorMessage} from '@/utils/helpers';
import {toast} from 'react-toastify';
import {Steps} from '.';
import Input from '@/shared/components/Inputs/Input';
import {CodeForm} from '../TwoStepAuthentication/CodeForm';

interface TwoStepAuthenticationDisableStep1Props {
  setStep: (step: number) => void;
  onClose: () => void;
}

const TwoStepAuthenticationDisableStep1: FC<TwoStepAuthenticationDisableStep1Props> = ({setStep, onClose}) => {
  const [code, setCode] = useState<string[]>(Array(6).fill(''));
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const codeValue = code.join('');
  const isCodeComplete = /^\d{6}$/.test(codeValue);

  const handleDisableClick = async () => {
    if (!password) return setPasswordError('Password is required');

    setIsLoading(true);
    try {
      await SuperAdminService.setAdmin2FactorDisabled({code: codeValue, password});
      setStep(Steps.SUCCESS);
    } catch (error) {
      toast.error(getErrorMessage(error));
      setCode(Array(6).fill(''));
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <Box>
      <Icon sx={twoStepAuthenticationDisableStyles.icon}>
        <SecurityIcon />
      </Icon>
      <Typography sx={twoStepAuthenticationDisableStyles.title}>Disable Two-Step Authentication</Typography>
      <Typography sx={twoStepAuthenticationDisableStyles.description}>
        If you disable two-step verification, your account will not have an additional layer of protection.
      </Typography>

      <Input
        label="Password"
        type="password"
        placeholder="Enter your password"
        errorMessage={passwordError}
        onChange={(value) => {
          setPassword(value);
          setPasswordError('');
        }}
      />
      <Typography sx={{marginTop: '20px'}}>Enter the 6-digit code from your authentication app.</Typography>
      <CodeForm code={code} handleCode={setCode} />

      <Box sx={twoStepAuthenticationDisableStyles.buttonWrapper}>
        <Button color="error" variant={OUTLINE} title="Cancel" onClick={onClose} />
        <Button color="error" title="Disable" onClick={handleDisableClick} disabled={!isCodeComplete || isLoading} />
      </Box>
    </Box>
  );
};

export default TwoStepAuthenticationDisableStep1;
